// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"91":"c1f98cad","98":"1318b129","208":"b151afff","564":"07e2acf7","594":"7292408a","619":"5c78cf03","644":"a427b996","844":"e6ec12a3"}[chunkId] + ".js";
};